import { isIOS, isNative } from "./platform";

// Apre il navigatore esterno con destinazione gia' impostata.
// provider: 'auto' | 'google' | 'apple' | 'waze'
export function openNavigation({ lat, lng, label = "", provider = "auto", origin = null }) {
  if (lat == null || lng == null) return false;
  const o = origin && origin.lat != null ? `${origin.lat},${origin.lng}` : "";
  let url;
  if (provider === "waze") {
    url = `https://waze.com/ul?ll=${lat},${lng}&navigate=yes`;
  } else if (provider === "apple") {
    url = `https://maps.apple.com/?daddr=${lat},${lng}${o ? `&saddr=${o}` : ""}&dirflg=d`;
  } else if (provider === "google") {
    url = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}${o ? `&origin=${o}` : ""}&travelmode=driving`;
  } else {
    url = isIOS()
      ? `https://maps.apple.com/?daddr=${lat},${lng}${o ? `&saddr=${o}` : ""}&dirflg=d`
      : `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}${o ? `&origin=${o}` : ""}&travelmode=driving`;
  }
  return openExternalUrl(url);
}

// Apre un URL nel browser/app di sistema (fuori dalla WebView su nativo).
export function openExternalUrl(url) {
  const target = isNative() ? "_system" : "_blank";
  try { window.open(url, target); return true; } catch (e) { window.location.href = url; return true; }
}

export const NAV_PROVIDERS = [
  { id: "google", label: "Google Maps" },
  { id: "apple", label: "Apple Maps" },
  { id: "waze", label: "Waze" },
];
